import {
  buildRecommendationPayload as buildRecommendationPayloadHelper,
} from '../components/chat/utils/recommendationPayloadHelpers'

const useRecommendationPayload = ({
  getAnswersMap,
  collectedAnswersRef,
  agentData,
  storeId,
  agentId,
  language
}) => {
  const buildRecommendationPayload = () => {
    return buildRecommendationPayloadHelper({
      answersMap: getAnswersMap(),
      collectedAnswers:
        collectedAnswersRef.current,
      agentData,
      storeId,
      agentId,
      language,
    })
  }

  return {
    buildRecommendationPayload,
  }
}

export default useRecommendationPayload